<div class="card-visualizer">
    <div class="card-visualizer__bg -top"></div>
    <div class="card-visualizer__bg -right"></div>
    <div class="card-visualizer__bg -left"></div>

    <div class="card-visualizer__bd" #card>
        <div class="card-visualizer__label">{{label}}</div>
        <div class="card-visualizer__no" #digits>
            <div class="card-visualizer__digit" *ngFor="let digit of (cardNumber | cardNo | stringToArray)">{{digit}}
            </div>
        </div>
    </div>

</div>